import { EventEmitter, Injectable, SimpleChanges } from '@angular/core';
import { FlightStatusForm } from '../models/interfaces/flight-status-form.interface';
import { FlightStatusBaseComponent } from './flight-status-base.component';

@Injectable()
export class FlightStatusHelperComponent extends FlightStatusBaseComponent {
  private airportSwappedEmitter?: EventEmitter<void>;

  clearError(changes: SimpleChanges): void {
    if (changes['selectedAirport']?.currentValue) {
      this.formHandler.handleAirportChange(
        changes['selectedAirport'].currentValue,
        this.flightStatusForm
      );
      // Revalidate and clear flight number error when airport is selected
      if (this.formSubmitted) {
        this.clearErrors();
        this.validateForm();
        this.errors['flightNumber'] = ''; // Clear flight number error after validation since we're using airport code
      }
    }
    if (changes['isSelected']?.currentValue) {
      this.formSubmitted = false;
      this.clearErrors();
      this.updateAirportErrorStates();
    }
  }

  protected setupAirportSwapHandler(emitter?: EventEmitter<void>): void {
    this.airportSwappedEmitter = emitter;
  }

  protected setupReactiveValidation(): void {
    this.airportService.onAirportSelectionChange((isSwap) =>
      this.handleAirportSelectionChange(isSwap)
    );
  }

  protected handleAirportSelectionChange(isSwap?: boolean): void {
    if (isSwap && this.airportSwappedEmitter) {
      this.airportSwappedEmitter.emit();
    }

    if (!this.formSubmitted) return;
    this.errors['route'] = '';
    this.errors['origin'] = '';
    this.errors['destination'] = '';
    const validationData = this.formValidationService.createValidationData(
      this.flightStatusForm
    );
    this.formValidationService.validateSameAirport(
      validationData,
      this.content as FlightStatusForm,
      this.errors
    );
    this.validateReactiveRequiredFields(validationData);
    this.errorsSignal.set({ ...this.errors });
    this.updateAirportErrorStates();
  }
}
